<template>
  <div
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left mt-3"
    v-if="avulso"
  >
    <transition name="esocial-modal-fade">
      <div class="esocial-modal-overlay" v-if="showProcedimento" @click.self="showProcedimento = false">
        <div class="esocial-modal">
          <div class="esocial-modal__header">
            <span class="esocial-modal__title">Inserir Novo Exame</span>
            <button type="button" class="esocial-modal__close" @click="showProcedimento = false">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="esocial-modal__body">
            <ed-input-auto-complete
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0"
              label="Pesquisar procedimento"
              v-model="bind.procedimento"
              :items="bind.procedimentos"
              :loading="bind.loadingProcedimento"
              @search="getProcedimento"
              clearable
              is-object
            />
          </div>

          <div class="esocial-modal__footer">
            <button type="button" class="esocial-search__btn esocial-search__btn--filter" @click="inserirProcedimento">
              <i class="fa fa-check"></i> Adicionar
            </button>
          </div>
        </div>
      </div>
    </transition>

    <div class="item-group">Informações da Consulta</div>

    <div class="row">
      <ed-input-date
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
        label="Data da Consulta"
        v-model="formData.consulta.aso_dt"
        :maxDaysTomorrow="1"
        required
      />

      <ed-input-select-tipo
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
        label="Tipo de Consulta"
        name="id_tipo_aso"
        tipo="46"
        v-model="formData.consulta.id_tipo_aso"
        required
      />

      <ed-input-select-tipo
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
        label="Aptidão"
        name="id_tipo_aptidao"
        tipo="185"
        v-model="formData.consulta.aptidao"
        required
      />
    </div>

    <div class="item-group mt-2">Informações do Médico Examinador</div>

    <div class="row">
      <ed-input-text
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
        label="Nome do Médico"
        v-model="formData.medico.nome"
        name="valor.medico.nome"
        required
      />

      <ed-input-text
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
        label="CRM do Médico"
        v-model="formData.medico.crm"
        name="valor.medico.crm"
        type="number"
        required
      />

      <ed-input-select
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
        label="Unidade Federativa do CRM"
        name="valor.medico.crm_uf"
        :items="parent.bind.estados"
        v-model="formData.medico.crm_uf"
        required
      />
    </div>

    <div class="item-group mt-2">
      Informações do Médico Coordenador do PCMSO
    </div>

    <div class="row">
      <ed-input-text
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
        label="Nome do Médico"
        v-model="formData.responsavel_pcmso.nome"
        name="valor.responsavel_pcmso.nome"
      />

      <ed-input-text
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
        label="CRM do Médico"
        v-model="formData.responsavel_pcmso.crm"
        name="valor.responsavel_pcmso.crm"
        type="number"
      />

      <ed-input-select
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
        label="Unidade Federativa do CRM"
        :items="parent.bind.estados"
        v-model="formData.responsavel_pcmso.crm_uf"
        name="valor.responsavel_pcmso.crm_uf"
      />
    </div>

    <div class="item-group mt-2">Procedimentos - Tabela 27 do eSocial</div>

    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <button type="button" class="esocial-search__btn esocial-search__btn--add" @click="showProcedimento = !showProcedimento">
          <i class="fa fa-plus-circle"></i> Inserir Novo Exame
        </button>

        <div class="procedimentos-table">
          <table>
            <thead>
              <tr>
                <th class="procedimentos-table__col-codigo">Código</th>
                <th>Exame</th>
                <th class="procedimentos-table__col-data">Data do Exame</th>
                <th class="procedimentos-table__col-resultado">Resultado</th>
                <th class="procedimentos-table__col-acoes"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!formData.exames.length">
                <td colspan="5" class="procedimentos-table__empty">Nenhum exame cadastrado</td>
              </tr>
              <tr v-for="(exame, index) in formData.exames" :key="index">
                <td>{{ exame.codigo }}</td>
                <td>{{ exame.nome }}</td>
                <td>
                  <ed-input-date v-model="exame.data" :maxDaysTomorrow="1" required />
                </td>
                <td>
                  <ed-input-select
                    :items="[
                      { id: 1, nome: 'Normal' },
                      { id: 2, nome: 'Alterado' },
                      { id: 3, nome: 'Estável' },
                      { id: 4, nome: 'Agravamento' },
                    ]"
                    v-model="exame.resultado"
                    required
                  />
                </td>
                <td>
                  <button type="button" class="procedimentos-table__delete" title="Remover exame" @click="removerProcedimento(index)">
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Fct from "common/fct";
import {
  EdInputText,
  EdInputDate,
  EdInputAutoComplete,
  EdInputSelect,
  EdInputSelectTipo,
} from "template";

export default {
  name: "esocial-s2220",
  mixins: [Fct],
  components: {
    EdInputText,
    EdInputDate,
    EdInputAutoComplete,
    EdInputSelect,
    EdInputSelectTipo,
  },

  props: {
    avulso: {
      type: Number,
      default: 0,
    },
    formData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    parent: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },

  watch: {
    "parent.response"() {
      this.formataLista();
    },
  },

  data() {
    return {
      bind: {
        procedimento: null,
        procedimentos: [],
        loadingProcedimento: false,
      },
      tableHead: [
        {
          key: "empresa",
          sortable: true,
          show_fdt: true,
          show_empresa_link: true,
          label: "Empresa",
        },
        {
          key: "funcionario",
          sortable: true,
          show_funcao: true,
          show_funcionario_link: true,
          label: "Funcionário",
        },
        {
          key: "consulta",
          sortable: true,
          show_consulta_link: true,
          label: "Consulta",
        },
        {
          key: "lote",
          sortable: true,
          show_lote_recibo: true,
          label: "Lote / Recibo",
        },
        {
          key: "tipo_status",
          sortable: true,
          label: "Status",
        },
        {
          key: "motivo_falha_geracao_label",
          sortable: true,
          label: "Motivo da Falha",
        },
        {
          key: "updated_at",
          sortable: true,
          show_user: true,
          label: "Data Atualização",
          info: "Data da última alteração deste evento: mudança de status, geração de XML ou vínculo a lote.",
        },
      ],
      showProcedimento: false,
    };
  },

  mounted() {
    if (!this.avulso) {
      this.formataLista();
    } else {
      this.getProcedimento();
    }
  },

  methods: {
    inserirProcedimento() {
      if (this.bind.procedimento) {
        let encontrado = false;

        this.formData.exames.forEach(element => {
            if(element.codigo == this.bind.procedimento.codigo){
              encontrado = true
            }
        });

        if (encontrado) {
          this.$root.$dialog.alert("Procedimento já foi inserido", "warning");
          return;
        }

        this.formData.exames.push({
          codigo: this.bind.procedimento.codigo,
          nome: this.bind.procedimento.nome,
          data: this.$utilidade.toDate(null,true),
          resultado: 1,
        });
        this.showProcedimento = !this.showProcedimento
      }
    },

    removerProcedimento(index) {
      this.formData.exames.splice(index, 1);
    },

    getProcedimento(_search) {
      this.bind.procedimentos = [];
      this.bind.loadingProcedimento = false;

      this.$root.$request
        .get("esocial/tabelas/conteudo/27", {
          search: _search,
          pagination: 100,
        })
        .then((result) => {
          this.bind.loadingProcedimento = false;

          if (result.status == 200) {
            result.data.data.forEach((element) => {
              let item = {
                id: element.id,
                codigo: element.codigo,
                nome: element.codigo + " - " + element.nome,
              };

              if (item.nome.length > 50) {
                item.nome = item.nome.substring(0, 100);
              }

              this.bind.procedimentos.push(item);
            });
          }
        });
    },

    formataLista: function () {
      if (!this.parent || !this.parent.response) return;

      var result = this.parent.response;

      this.parent.tableHead = this.tableHead;

      if (!result.data || !result.data.data) {
        this.parent.tableData = [];
        return;
      }

      var tableData = [],
        arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        arrData[i]._nome =
          arrData[i].empresa.nome + " - " + arrData[i].funcionario.nome;
        arrData[i].funcao = arrData[i].funcionario.funcao
          ? arrData[i].funcionario.funcao
          : null;
        arrData[i].fdt = arrData[i].funcionario.fdt
          ? arrData[i].funcionario.fdt
          : null;
        arrData[i].consulta = arrData[i].consulta ? arrData[i].consulta : null;

        var item = {
          consulta: arrData[i].id_con,
          id_con: arrData[i].id_con,
          empresa: arrData[i].empresa.nome,
          funcionario: arrData[i].funcionario.nome,
          funcao: arrData[i].funcao ? arrData[i].funcao.nome : null,
          tipo_status: arrData[i].tipo_status ? arrData[i].tipo_status.descricao: null,
          motivo_falha_geracao_label: arrData[i].motivo_falha_geracao_label || "",
          fdt: arrData[i].fdt,
          id: arrData[i].id,
          lote: arrData[i].lote || "",
          recibo:
            '<span style="color:' +
            (
              arrData[i].tipo_status && arrData[i].tipo_status.id === 380 && arrData[i].recibo
                ? "orange"
                : (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "")
            ) +
            '">' +
            (arrData[i].recibo ? arrData[i].recibo : "---") +
            "</span>",
          updated_at:
            '<span style="color:' +
            (
            arrData[i].tipo_status && arrData[i].tipo_status.id === 380 && arrData[i].recibo
              ? "orange"
              : (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "")
          ) +
            '">' +
            this.toDate(arrData[i].updated_at, false) +
            "</span>",
          dt_cad:
            '<span style="color:' +
            (
              arrData[i].tipo_status && arrData[i].tipo_status.id === 380 && arrData[i].recibo
                ? "orange"
                : (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "")
            ) +
            '">' +
            this.toDate(arrData[i].created_at, false) +
            "</span>",
          tipo_status:
            '<span style="color:' +
            (
              arrData[i].tipo_status && arrData[i].tipo_status.id === 380 && arrData[i].recibo
                ? "orange"
                : (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "")
            ) +
            '">' +
            (arrData[i].tipo_status ? arrData[i].tipo_status.descricao: null) +
            "</span>",
          _data: arrData[i],
          buttons: [],
          options: {
            disable_delete:
              arrData[i].tipo_status &&
              [332, 330].indexOf(arrData[i].tipo_status.id) != -1 &&
              arrData[i].recibo &&
              this.$root.$session.validarPermissao(586)
                ? false
                : true,
          },
        };

        if (!arrData[i].recibo && !arrData[i].xml) {
          item.buttons.push({
            icon: "fa-solid fa-file-circle-plus",
            color: "default",
            title: "Gerar arquivo XML",
            style: "font-size:12px;color:" + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "#e03a3a"),
            click: this.parent.onEdit,
          });
        } else {

          // if (arrData[i].tipo_status.id != 332) {
            item.buttons.push({
              icon: "fa fa-pen",
              color: "default",
              title: "Atualizar dados do evento",
              style: "color:#34c142",
              click: this.parent.onUpdateUid,
            });
          // }

          item.buttons.push({
            icon: "fa fa-download",
            color: "default",
            title: "Baixar arquivo XML",
            style: "color:#34c142",
            click: this.parent.onDownloadXML,
          });

          if (!arrData[i].lote) {
            item.buttons.push({
              icon: "fa fa-file-archive-o",
              color: "default",
              title: "Gerar novo lote para esse arquivo",
              style: "color:#666",
              click: this.parent.onGerarLote,
            });
          }

          if (!arrData[i].recibo && arrData[i].tipo_status.id != 380) {
            item.buttons.push({
              icon: "fa fa-refresh",
              color: "default",
              title: "Atualizar arquivo XML",
              style: "color:#568cdd",
              click: this.parent.onEdit,
            });
          }

          if (
            arrData[i].recibo &&
            arrData[i].tipo_status &&
            [332, 335].indexOf(arrData[i].tipo_status.id) != -1
          ) {
            item.buttons.push({
              icon: "fa fa-times-circle",
              color: "default",
              title: "Excluir arquivo XML",
              style: "color:#d82d2d",
              click: this.parent.onDelete,
            });
          }
        }

        if (
          arrData[i].motivo_falha_geracao == "SEM_MATRICULA" &&
          (arrData[i].id_fun || (arrData[i].funcionario && arrData[i].funcionario.id))
        ) {
          item.buttons.push({
            icon: "fa fa-whatsapp",
            color: "info",
            title: "Falha ao gerar XML por falta de matrícula — enviar WhatsApp ao contador solicitando a correção.",
            click: this.parent.onDispararWhatsappAtualizarMatriculaContador,
          });
        }

        tableData.push(item);
      }

      this.parent.tableData = tableData;
      this.parent.pagination = result.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.esocial-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1500;
}

.esocial-modal {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
  width: 620px;
  max-width: 92vw;
  max-height: 85vh;
  overflow: hidden;
}

.esocial-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 3px solid rgba(168, 121, 31, 0.45);
}

.esocial-modal__title {
  font-size: 15px;
  font-weight: 700;
  color: #1f2329;
}

.esocial-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: #f1f2f4;
  color: #6b7280;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;

  &:hover {
    background: #e4e7ed;
    color: #1f2329;
  }
}

.esocial-modal__body {
  padding: 20px 22px;
  overflow-y: auto;
  flex: 1 1 auto;
}

.esocial-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 22px;
  border-top: 1px solid #eef0f2;
}

.esocial-modal-fade-enter-active,
.esocial-modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.esocial-modal-fade-enter,
.esocial-modal-fade-leave-to {
  opacity: 0;
}

.esocial-search__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  box-sizing: border-box;
  padding: 0 14px;
  border: 1px solid #e4e7ed;
  background: #fff;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.15s, border-color 0.15s;

  &:hover {
    background: #f7f8f9;
  }

  &--filter {
    color: rgb(168, 121, 31);
    border-color: #f0dfb8;
    background: #fdf8ee;

    &:hover {
      background: #f5e6c3;
    }
  }

  &--add {
    color: #1a8a3e;
    border-color: #bfe6cc;
    background: #eefbf1;
    margin-bottom: 10px;

    &:hover {
      background: #dcf4e3;
    }
  }
}

.procedimentos-table {
  overflow-x: auto;
  border: 1px solid #eef0f2;
  border-radius: 8px;

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
  }

  thead th {
    text-align: left;
    padding: 9px 10px;
    background: #f0f1f3;
    color: #6b7280;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    white-space: nowrap;
  }

  tbody tr {
    border-top: 1px solid #eef0f2;

    &:hover {
      background: #f7f9fb;
    }
  }

  td {
    padding: 6px 10px;
    vertical-align: middle;
    color: #1f2329;
  }

  &__col-codigo {
    width: 110px;
  }

  &__col-data,
  &__col-resultado {
    width: 170px;
  }

  &__col-acoes {
    width: 50px;
  }

  &__empty {
    text-align: center;
    color: #9aa0a8;
    padding: 20px 0;
  }

  &__delete {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border: 1px solid transparent;
    background: transparent;
    border-radius: 6px;
    color: #c0392b;
    cursor: pointer;
    font-size: 11px;

    &:hover {
      background: #fff;
      border-color: #f3c9c9;
    }
  }
}
</style>



// WEBPACK FOOTER //
// s2220.vue?7df98d33